import * as Sentry from "@sentry/react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";

import { useGetCurrentLoanApplicationID } from "@krea/customer-features/hooks";
import { ISelectLenderResponseVariables } from "@krea/customer-features/shared-components/bid-dashboards/bid-dashboard/types";
import {
  CURRENT_LOAN_APPLICATION_STORE_KEY,
  SELECTED_LENDER_RESPONSE_FIELD_REQUESTS_STORE_KEY,
} from "@krea/customer-features/store/queryClient";
import { INoContentResponse } from "@krea/shared/types/response";

import { selectLenderResponse } from "@/services/api/lender-response/actions";

export const useSelectLenderResponse = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const loanApplicationID = useGetCurrentLoanApplicationID();

  return useMutation<
    INoContentResponse,
    unknown,
    ISelectLenderResponseVariables
  >({
    mutationFn: async ({ lenderResponseID }) => {
      await selectLenderResponse(lenderResponseID);
    },
    onSuccess: async () => {
      // Await the updated  loan application data with corrct state
      await queryClient.fetchQuery({
        queryKey: [CURRENT_LOAN_APPLICATION_STORE_KEY, loanApplicationID],
        staleTime: 0,
      });

      // we dont need to await the selected lender response data,
      // as its better to navigate to the new page and let the data load in the background
      queryClient.prefetchQuery({
        queryKey: [
          SELECTED_LENDER_RESPONSE_FIELD_REQUESTS_STORE_KEY,
          loanApplicationID,
        ],
        staleTime: 0,
      });

      navigate("/");
    },
    onError: (err) => {
      console.error("Failed selecting bid: err", err);
      Sentry.captureException(err);
    },
  });
};
